export default __webpack_public_path__ + "static/media/logo-gemina-store.441d09fe.jpg";